<template>
    <div class="mx-3">
        <div class="row border-bottom ml-1 mr-1">
            <div class="h2 col-6">{{ title }}</div>
        </div>

        <nav class="my-4">
            <div class="nav nav-tabs" id="claimTab">
                <a class="nav-item nav-link active" id="nav-active-tab" data-toggle="tab" href="#nav-active" role="tab" aria-controls="nav-active" aria-selected="true">Active</a>
                <a class="nav-item nav-link" id="nav-inactive-tab" data-toggle="tab" href="#nav-inactive" role="tab" aria-controls="nav-inactive" aria-selected="false">Hidden</a>
            </div>
        </nav>
        <div class="tab-content" id="nav-tabContent">
            <div class="tab-pane fade show active" id="nav-active" role="tabpanel" aria-labelledby="nav-active-tab">
                <disputable-authorizations-list title="active" :loading="loading" :documents="active" @refresh="refresh"></disputable-authorizations-list>            
            </div>
            <div class="tab-pane fade show" id="nav-inactive" role="tabpanel" aria-labelledby="nav-inactive-tab">
               <disputable-authorizations-list title="hidden" :loading="loading" :documents="inactive" @refresh="refresh"></disputable-authorizations-list>
            </div>
        </div>        
    </div>    
</template>

<script>
import DisputableAuthorizationsList from './DisputableAuthorizationsList.vue';

export default {
    components: {
        DisputableAuthorizationsList
    },
    props: {
        title: null
    },
    data() {
         return {
             active: [],
             inactive: [],
             loading: true
         }
    },    
    methods: {
        refresh: function () {
            this.loading = true;
            axios.get('/ajax/reports/disputable/authorization/documents')
                .then(response => {
                    this.active = response.data.active;
                    this.inactive = response.data.inactive;
                    this.loading = false;
                });
        }
    },
    created() {
        this.refresh();
    }
}

$(function() {
    
    $('#nav-active-tab').click(function() {
        $('#nav-active').show();
        $('#nav-inactive').hide();
    });
    
    $('#nav-inactive-tab').click(function() {
        $('#nav-active').hide();
        $('#nav-inactive').show();
    });        
});
</script>

<style scoped>
    .table td.fit, 
    .table th.fit {
        white-space: nowrap;
        width: 1%;
    }
</style>